import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/utils/app';

export default class Mediabox extends React.Component {
    getVariations() {
        const variations = this.props.variations.slice(0);
        if (!this.props.meta && variations.indexOf('no-meta-data') === -1) {
            variations.push('no-meta-data');
        }

        return variations;
    }

    renderMeta() {
        const { meta } = this.props;
        if (meta) {
            return <div className="mediabox__meta-data">{meta}</div>;
        }
    }

    renderRibbon() {
        if (this.props.ribbon) {
            return <div className="mediabox__ribbon">{this.props.ribbon}</div>;
        }
    }

    render() {
        const classes = getComponentClasses('mediabox', this.getVariations());
        return (
            <div
                className={classes}
                data-mediabox-selected={this.props.selected ? true : undefined}
                data-mediabox-disabled={this.props.disabled ? true : undefined}
            >
                <div className="mediabox__media-frame">
                    <div className="mediabox__media">{this.props.children}</div>
                </div>
                {this.renderRibbon()}
                {this.renderMeta()}
            </div>
        );
    }
}
Mediabox.propTypes = {
    children: PropTypes.node.isRequired,
    ribbon: PropTypes.node,
    meta: PropTypes.node,
    variations: PropTypes.array,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
};
Mediabox.defaultProps = {
    meta: null,
    variations: [],
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/mediabox.jsx